import { IconWrapper } from '../runtime';
export default IconWrapper('download', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.00276 8.24997V14.75M8.00276 14.75L6.40625 13.1535M8.00276 14.75L9.59927 13.1535",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5 10.75H4C2.34315 10.75 1 9.40685 1 7.75C1 6.09315 2.34315 4.75 4 4.75C4.04199 4.75 4.08378 4.75086 4.12536 4.75257C4.5685 3.02604 6.13523 1.75 8 1.75C9.86477 1.75 11.4315 3.02604 11.8746 4.75257C11.9162 4.75086 11.958 4.75 12 4.75C13.6569 4.75 15 6.09315 15 7.75C15 9.40685 13.6569 10.75 12 10.75H11",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});